<form [formGroup]="form" (ngSubmit)="create()">
  <div class="submit-form">
    <div *ngIf="!isRequestSuccess">
      <h3 class="title-page text-primary">{{title}}</h3>
      <p>Những trường có <label style="color: red;">(*)</label> là bắt buộc </p>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="declarationNumber">Số tờ khai <label style="color: red;">(*) Tờ khai 11
                số</label> </label>
            <input type="text" onKeyPress="if(this.value.length==11) return false;" maxlength="11" minlength="11"
              [ngClass]="{'is-invalid': submitted && f.declarationNumber.errors }" class="form-control"
              formControlName="declarationNumber" id="declarationNumber" required name="Số tờ khai" />
            <div *ngIf="submitted && f.declarationNumber.errors" class="invalid-feedback">
              <div *ngIf="f.declarationNumber.errors.required">Vui lòng nhập số tờ khai.</div>
            </div>
            <div *ngIf="submitted && isEnoughNumber" class="invalid-feedback">
              <div *ngIf="f.declarationNumber.errors.required">Vui lòng nhập số tờ khai 11 chữ số.</div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label" for="codeType">Mã loại hình</label>
            <input class="form-control" formControlName="codeType" id="codeType" name="codeType" />
          </div>
          <div class="mb-3">
            <label class="form-label" for="enterpriseName">Tên doanh nghiệp <label
                style="color: red;">(*)</label></label>
            <input class="form-control" [ngClass]="{'is-invalid': submitted && f.enterpriseName.errors }"
              id="enterpriseName" formControlName="enterpriseName" required name="enterpriseName" />
            <div *ngIf="submitted && f.enterpriseName.errors" class="invalid-feedback">
              <div *ngIf="f.enterpriseName.errors.required">Vui lòng nhập tên doanh nghiệp.</div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label" for="productName">Tên hàng hóa <label style="color: red;">(*)</label></label>
            <input class="form-control" [ngClass]="{'is-invalid': submitted && f.productName.errors }" id="productName"
              formControlName="productName" required name="productName" />
            <div *ngIf="submitted && f.productName.errors" class="invalid-feedback">
              <div *ngIf="f.productName.errors.required">Vui lòng nhập tên doanh nghiệp.</div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label" for="countProduct">Số lượng cont/hàng rời <label
                style="color: red;">(*)</label></label>
            <input class="form-control" [ngClass]="{'is-invalid': submitted && f.countProduct.errors }"
              id="countProduct" formControlName="countProduct" required name="countProduct" />
            <div *ngIf="submitted && f.countProduct.errors" class="invalid-feedback">
              <div *ngIf="f.countProduct.errors.required">Vui lòng nhập số lượng cont/hàng rời.</div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label" for="address">Địa điểm kiểm tra thực tế hàng hóa <label
                style="color: red;">(*)</label></label>
            <input class="form-control" [ngClass]="{'is-invalid': submitted && f.address.errors }" id="address"
              formControlName="address" required name="address" />
            <div *ngIf="submitted && f.address.errors" class="invalid-feedback">
              <div *ngIf="f.address.errors.required">Vui lòng nhập địa điểm kiểm tra thực tế hàng hóa.</div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label" for="expectedDeliveryDate">Ngày dự kiến xuất trình hàng <label
                style="color: red;">(*)</label></label>
            <input mask="d0/M0/0000" [showMaskTyped]="true" [dropSpecialCharacters]="false" class="form-control"
              [ngClass]="{'is-invalid': submitted && f.expectedDeliveryDate.errors }" id="expectedDeliveryDate"
              formControlName="expectedDeliveryDate" required name="expectedDeliveryDate" />
            <div *ngIf="submitted && f.expectedDeliveryDate.errors" class="invalid-feedback">
              <div *ngIf="f.expectedDeliveryDate.errors.required">Vui lòng nhập ngày dự kiến xuất trình hàng.</div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label" for="expectedDeliveryHour">Giờ dự kiến xuất trình hàng <label
                style="color: red;">(*)</label></label>
            <input mask="Hh:m0" [showMaskTyped]="true" [dropSpecialCharacters]="false" class="form-control"
              [ngClass]="{'is-invalid': submitted && f.expectedDeliveryHour.errors }" id="expectedDeliveryHour"
              formControlName="expectedDeliveryHour" required name="expectedDeliveryHour" />
            <div *ngIf="submitted && f.expectedDeliveryHour.errors" class="invalid-feedback">
              <div *ngIf="f.expectedDeliveryHour.errors.required">Vui lòng nhập giờ dự kiến xuất trình hàng.</div>
            </div>
          </div>
          <h5>Thông tin người xuất trình hàng hóa (Nhận phản hồi)</h5>
          <div class="mb-3">
            <label class="form-label" for="receiverName">Họ và tên <label style="color: red;">(*)</label></label>
            <input class="form-control" [ngClass]="{'is-invalid': submitted && f.receiverName.errors }"
              id="receiverName" formControlName="receiverName" required name="receiverName" />
            <div *ngIf="submitted && f.receiverName.errors" class="invalid-feedback">
              <div *ngIf="f.receiverName.errors.required">Vui lòng nhập Họ và tên.</div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label" for="receiverPhone">Số điện thoại <label style="color: red;">(*)</label></label>
            <input class="form-control" [ngClass]="{'is-invalid': submitted && f.receiverPhone.errors }"
              id="receiverPhone" formControlName="receiverPhone" required name="receiverPhone" />
            <div *ngIf="submitted && f.receiverPhone.errors" class="invalid-feedback">
              <div *ngIf="f.receiverPhone.errors.required">Vui lòng nhập số điện thoại.</div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label" for="note">Ghi chú </label>
            <textarea class="form-control" id="note" formControlName="note" name="note" rows="4" cols="50"></textarea>
          </div>
          <button type="submit" class="btn btn-success">Đăng ký kiểm hóa</button>
        </div>
        <div class="col-md-6" style="font-weight: bold;">
          <div class="mb-3">
            CBCC kiểm tra thực tế hàng hóa
          </div>
          <div class="mb-3" *ngFor="let contact of contacts; let i = index">
           {{i + 1}}. {{contact.name}} - {{contact.position}} - {{contact.phoneNumber}}
          </div>
          <div class="mb-3">
            <img src="{{qrImage}}" width="290" height="290" />
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isRequestSuccess">
      <h5 class="text-success">Bạn đăng ký kiểm hóa thành công.</h5>
    </div>
  </div>
</form>
